import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { truncate } from 'lodash';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION,
	PARAM_LABEL_USER
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { Authority } from 'src/app/shared/models/security/authority';

@Component({
	selector: 'app-nav-systeme',
	templateUrl: './nav-systeme.component.html',
	styleUrls: ['./nav-systeme.component.scss']
})
export class NavSystemeComponent implements OnInit {
	tabs: any[];
	detailTab: any;

	@Input() addable = false;
	@Input() isImportable = false;
	@Input() isExportable = false;
	@Output() importingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() exportingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() addEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

	user: User;

	constructor(private router: Router, private facade: FacadeService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();

		const labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		/**
		 * Elements de la navbar dans gestion des données
		 */
		this.tabs = [];
			this.tabs.push({
				name: 'Système',
				path: '/systeme/systeme/list',
				parentPath: '/systeme/systeme'
			});
			// this.tabs.push({
			// 	name: "Expertise/Type d'handicap",
			// 	path: '/systeme/expertise/list',
			// 	parentPath: '/systeme/expertise'
			// });
	
		//}
	}

	scrollTop() {
		window.scroll(0, 0);
	}

	userAsAnyAuthority(listAuthority: Authority[]) {
		return listAuthority.some((authority) => authority === this.user?.profile.id);
	}

	isRouterActive(path: string) {
		return this.router.isActive(path, false);
	}

	isRouterActiveForChild(path: string) {
		return this.router.isActive(path, false);
	}
}
